import type { BulkPhotoAction, ModerationAction } from '@/services/photovogue';

export type ModerationButtonVariant = 'default' | 'outline' | 'destructive';

/**
 * The active editorial moderation actions, shared by the per-photo detail bar and
 * the bulk toolbar. `destructive` actions are wrapped in a confirmation dialog.
 */
export const MODERATION_ACTIONS: {
  action: ModerationAction;
  label: string;
  variant: ModerationButtonVariant;
  destructive?: boolean;
}[] = [
  { action: 'approve', label: 'Approve', variant: 'default' },
  { action: 'reject', label: 'Reject', variant: 'outline' },
  { action: 'ban', label: 'Ban', variant: 'destructive', destructive: true },
];

export const BULK_PHOTO_ACTIONS: {
  action: BulkPhotoAction;
  label: string;
  variant: ModerationButtonVariant;
  destructive?: boolean;
}[] = [
  ...MODERATION_ACTIONS,
  { action: 'best', label: 'Mark as Best', variant: 'outline' },
];

export const formatDate = (iso: string | null): string =>
  iso
    ? new Date(iso).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    : '—';
